/**
 * --------------------------------------------------
 * configuration for global need
 * --------------------------------------------------
 */

export const version = "0.6.0";
